module.exports = __webpack_public_path__ + "static/video-ore-agence-00cb2ba73d3add2ff5d137c9e03982bd.mp4";